import React, { useEffect, useState } from "react";
import { api, rupee } from "../lib/api";

export default function Reports() {
  const [rows, setRows] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const load = () => {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    api.get("/reports/sales-by-category", { params }).then((r) => setRows(r.data));
  };
  useEffect(() => { load(); }, [start, end]);

  const total = rows.reduce((a, b) => a + b.revenue, 0);

  return (
    <div className="p-6 md:p-10 max-w-5xl mx-auto" data-testid="reports-root">
      <h1 className="font-display font-bold text-3xl mb-6">Sales by category</h1>
      <div className="card-soft p-4 mb-4 flex gap-3 flex-wrap">
        <div><label className="text-xs" style={{ color: "var(--text-muted)" }}>From</label><input data-testid="rep-start" type="date" value={start} onChange={(e) => setStart(e.target.value)} className="h-11 px-3 rounded-md border bg-white block" style={{ borderColor: "var(--border-soft)" }} /></div>
        <div><label className="text-xs" style={{ color: "var(--text-muted)" }}>To</label><input data-testid="rep-end" type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="h-11 px-3 rounded-md border bg-white block" style={{ borderColor: "var(--border-soft)" }} /></div>
      </div>
      <div className="card-soft">
        <table className="w-full text-sm zebra">
          <thead><tr className="text-left" style={{ color: "var(--text-muted)" }}><th className="p-3">Category</th><th className="text-right">Units</th><th className="text-right">Revenue</th><th className="text-right">% share</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="text-center py-10" style={{ color: "var(--text-muted)" }}>No sales in this range yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.category} className="border-t" style={{ borderColor: "var(--border-soft)" }} data-testid={`rep-row-${r.category}`}>
                <td className="p-3 font-medium">{r.category}</td>
                <td className="text-right num">{r.units}</td>
                <td className="text-right num font-semibold">{rupee(r.revenue)}</td>
                <td className="text-right num">{total ? ((r.revenue / total) * 100).toFixed(1) : "0"}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
